export const formErrorMessages = {
    username: "User name should not be empty",
    password: "Password should not be empty"
}

export const isDevEnvironment = process.env.NODE_ENV === "development";

export const apiErrorMessages = {
    "1": "Error: Internal application error.",
    "2": "Error: Internal application error.",
    "3": "Error: Unhandled application error.",
    "4": "Error: The user making the request cannot be identified.",
    "5": "Error: The user making the request is not authorized.",
    "6": "Error: Error with metadata resources.",
    "7": "Error: The operation did not complete.  The location of the selected device is currently unavailable. Please wait a few minutes and try again.  If the problem persists, contact your Tracer Ensemble Server Administrator.",
    "10": "Error: Control does not reference valid Object.", 
    "11": "Error: Property not in Object Constant state.",
    "12": "Error: Property not Constant.",
    "13": "Error: Unit Conversion failed for input value.",
    "14": "Error: Input outside valid range for this property.",
    "15": "Error: Input below lower limit for this property.",
    "16": "Error: Input above upper limit for this property.",
    "17": "Error: Validation failed for requested setpoint changes.",
    "19": "Error: The operation did not complete. The selected device is currently busy. Please wait a few minutes and try again.",
    "20": "Error: The operation did not complete. The selected device is currently offline. Please try again when the device is online.",
    "21": "Error: The operation did not complete. The selected device did not respond to the request in the allotted time. Please wait a few minutes and try again.",
    "22": "Error: The operation did not complete. A communication error occurred while trying to process your request.  Please wait a few minutes and try again. If the problem persists, contact your Tracer Ensemble Server Administrator.",
    "23": "Error: The operation did not complete. The selected device has denied Tracer Ensemble the access to perform your request.",
    "24": "Warning: The location of the selected device is currently unavailable. Please wait a few minutes and try again.  If the problem persists, contact your Tracer Ensemble Server Administrator.",
    "25": "Warning: The Tracer Ensemble server is currently unable to communicate with the device.  Wait a few minutes and try again, or contact your Tracer Ensemble server administrator.",
    "26": "Error: Property not supported."
}

export const getOrdinalSuffixOf = (number) => {
    let j = number % 10, k = number % 100;
    if (j === 1 && k !== 11) {
        return number + "st";
    }
    if (j === 2 && k !== 12) {
        return number + "nd";
    }
    if (j === 3 && k !== 13) {
        return number + "rd";
    }
    return number + "th";
}